import { Component, Input, EventEmitter, Output, ViewChild, OnChanges } from '@angular/core';
import { LogEntry, TimeLogSummary } from 'globals/store/tasks.data';
import { openDialogGetResult } from 'src/app/helpers/angular-helpers';
import { MatDialog } from '@angular/material/dialog';
import { TimeLogDialogComponent, TimeLogDialogData } from 'src/app/components/wizards/time-log-dialog.component';
import { UserService } from 'src/app/services/user.service';
import { TimeLogData, timeLogColumns} from 'src/app/helpers/table-column-types';
import { TableColumn } from 'src/app/helpers/table.data';
import { timeLogColumnsById, allDefaultTimeLogColumns } from './../../helpers/table-helpers';
import { saveTable } from '../performers/performerSharedFunctions';
import { NestedTableComponent } from '../../components/nested-table/nested-table.component';
import { TimeLogSummaryComponent } from './time-log-summary.component';
import { createId } from 'globals/helpers/helpers';

@Component({
    selector: 'time-log',
    template: `
<time-log-summary 
  [timeLogSummary]="timeLogSummary" 
  [showLogButton]="!readOnly"
  [showMenu]="true"
  (onExport)="saveTable()"
  (newLog)="addNewLog()"
></time-log-summary>
<nested-table
  class="time-log-table"
  emptyMessage="No time logged in this task"
  [items]="timeLogData"
  [columns]="columns"
  [columnsById]="columnsById"
  [bigSecondColumn]="true"
  [readOnly]="true"
  [defaultSelectedColumnId]="defaultColumnId"
  (selectItem)="openTimeLog($event)"
  ></nested-table>
`,
    styleUrls: ['./time-log.scss'],
    standalone: true,
    imports: [NestedTableComponent, TimeLogSummaryComponent]
})

export class TimeLogComponent implements OnChanges {

  @Input() readOnly = true
  @Input() timeLogSummary: TimeLogSummary
  @Input() timeLogData: TimeLogData[]
  @Input() taskTitle = 'Task'

  @Output() newLog: EventEmitter<LogEntry> = new EventEmitter()
  @Output() editedLog: EventEmitter<LogEntry> = new EventEmitter()
  @Output() deleteLog: EventEmitter<string> = new EventEmitter()

  @ViewChild('logButton') logButton: any
  @ViewChild(NestedTableComponent) nestedTable: NestedTableComponent<TimeLogData>

  columns: TableColumn[] = allDefaultTimeLogColumns
  columnsById = timeLogColumnsById
  defaultColumnId = timeLogColumns.date

  constructor(
    private dialog: MatDialog,
    private userService: UserService,
  ) { }

  ngOnChanges(changes) {
    // console.log(changes)
  }

  
  openTimeLog(timeLogRow: TimeLogData) {
    if (!this.readOnly) this.editLog(timeLogRow.timeLog)
  }

  async editLog(timeLog: LogEntry) {
    const data: TimeLogDialogData = {
      notes: timeLog.content,
      time: timeLog.loggedTime,
      date: timeLog.createdAt.hasOwnProperty('seconds') ? new Date(timeLog.createdAt['seconds'] * 1000) : timeLog.createdAt,
      delete: true
    }
    const result = await openDialogGetResult<TimeLogDialogData>(this.dialog, TimeLogDialogComponent, { width: '300px', disableClose: true, data })
    if (!result) return
    if (result.delete) {
      this.deleteLog.emit(timeLog.id)
      return
    } 
    const logEntry: LogEntry = {
      id: timeLog.id,
      content: result.notes,
      loggedTime: result.time,
      createdBy: this.userService.email,
      createdAt: result.date,
    }
    this.editedLog.emit(logEntry)
  }

  saveTable() {
    saveTable('time log' ,`${this.taskTitle} time log table`, this.dialog, this.nestedTable)
  }

  async addNewLog() {
    const rect = document.getElementById('logButton').getBoundingClientRect()
    const { bottom, right } = rect
    const data: TimeLogDialogData = {
      position: { top: bottom + 4, left: right - 300 }
    }
    const result = await openDialogGetResult<TimeLogDialogData>(this.dialog, TimeLogDialogComponent, { width: '300px', disableClose: false, backdropClass: 'clear', data })
    if (!result) return
    const logEntry: LogEntry = {
      id: createId(),
      content: result.notes,
      loggedTime: result.time,
      createdBy: this.userService.email,
      createdAt: result.date,
    }
    this.newLog.emit(logEntry)
  }

}